module.exports = __webpack_public_path__ + "img/Mobile-screen.e99643b7.jpg";